import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { isTerminalStatus } from 'modules/payroll_bundle/lib/Incidences/Status'
import { InstanceProps } from 'modules/payroll_bundle/pages/IncidencesPage/components/_StatusChangeDialog/types'

const DiscardDialog: React.FC<InstanceProps> = ({
  incidences = [],
  syncing,
  results,
  onDismiss,
  onCommit,
}) => {
  const filteredIncidenceIds = new Set(
    incidences.filter((incidence) => !isTerminalStatus(incidence.status)).map((i) => i.id)
  )

  // TODO: improve error handling
  const message = results?.success
    ? i18n.t('bookkeepers.incidence.bulk_status_changes.success')
    : filteredIncidenceIds.size
      ? i18n.t('bookkeepers.incidence.bulk_status_changes.discard.to_discard_message')
      : i18n.t('bookkeepers.incidence.bulk_status_changes.discard.cannot_discard_message')

  const disableUI = !filteredIncidenceIds.size || syncing

  const success = results?.success

  return (
    <Modal
      illustration="delete"
      title={i18n.t('bookkeepers.incidence.bulk_status_changes.discard.modal_title')}
      description={results?.success === false ? undefined : message}
      onClose={onDismiss}
      footer={
        <>
          <Button type="secondary" onClick={onDismiss} disabled={syncing}>
            {i18n.t('common.cancel')}
          </Button>
          {success ? (
            <Button type="positive" onClick={onDismiss}>
              {i18n.t('common.done')}
            </Button>
          ) : (
            <Button
              type="negative"
              onClick={() => onCommit(filteredIncidenceIds)}
              disabled={disableUI}
            >
              {i18n.t('bookkeepers.incidence.bulk_status_changes.discard.action')}
            </Button>
          )}
        </>
      }
    >
      {syncing && <Loading inline />}
      {results?.errorMessages &&
        !syncing &&
        (results.success ? (
          <Callout
            type="warning"
            description={i18n.t('bookkeepers.incidence.bulk_status_changes.partial_success')}
          />
        ) : (
          <Callout
            type="critical"
            description={i18n.t('bookkeepers.incidence.bulk_status_changes.dialog_error')}
          />
        ))}
    </Modal>
  )
}

export default DiscardDialog
